/** Routes with wide data tables that should use full header/content width */
export const FLUID_LAYOUT_PATHS = ['/cdrsTenant', '/cdrs-user'];

export const isFluidLayoutPath = (pathname = '') =>
    FLUID_LAYOUT_PATHS.some((path) => pathname.includes(path));

/** Swap fixed Bootstrap containers for fluid on wide pages */
export const toFluidContainerClass = (classList = [], useFluid = false) => {
    const classes = Array.isArray(classList) ? classList : String(classList).split(' ').filter(Boolean);
    if (!useFluid) {
        return classes.join(' ');
    }
    return classes
        .map((cls) => (cls === 'container-xxl' || cls === 'container' ? 'container-fluid' : cls))
        .join(' ');
};
